import { z } from "zod";

const attachmentSchema = z.object({
  fileName: z.string().trim().min(1).max(255),
  contentType: z.enum([
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ]),
  base64: z.string().min(1),
});

export const grantsAssessmentSchema = z.object({
  name: z.string().trim().min(1, "Name is required").max(200),
  phone: z.string().trim().min(1, "Phone is required").max(50),
  email: z
    .string()
    .trim()
    .max(320)
    .email({ message: "Please enter a valid email address" })
    .optional()
    .or(z.literal("")),
  postcode: z.string().trim().min(1, "Postcode is required").max(20),
  property_type: z.string().trim().max(100).optional().or(z.literal("")),
  message: z.string().trim().max(5000).optional().or(z.literal("")),
  consent: z.literal(true, {
    errorMap: () => ({ message: "Please confirm you agree to be contacted." }),
  }),
  source_page: z.string().trim().min(1).max(500),

  gclid: z.string().trim().max(500).optional().or(z.literal("")),
  honeypot: z.string().max(0).optional(),
  attachment: attachmentSchema.optional(),
});

export type GrantsAssessmentInput = z.infer<typeof grantsAssessmentSchema>;

export const GRANTS_ATTACHMENT_MAX_BYTES = 10 * 1024 * 1024;

export const GRANTS_ATTACHMENT_ACCEPT =
  ".pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document";

export const GRANTS_ATTACHMENT_MIME_TYPES = new Set([
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
]);

export function validateGrantsAttachmentFile(file: File): string | null {
  if (!GRANTS_ATTACHMENT_MIME_TYPES.has(file.type)) {
    return "Please upload a PDF or Word document (.pdf, .doc, .docx).";
  }
  if (file.size > GRANTS_ATTACHMENT_MAX_BYTES) {
    return "File must be 10MB or smaller.";
  }
  return null;
}
